const countries = require('@mtntop/utils/src/constants/countries.json');

export const getFlagEmoji = (countryCode) => {
  return countryCode
    .split('')
    .map(char => String.fromCodePoint(char.charCodeAt(0) + 127397))
    .join('');
};

export const getCountryName = (countryCode) => {
  const country = countries.find(c => c.code === countryCode);
  return country ? country.name : countryCode;
};